module.exports = "/_next/static/images/image_placeholder-43eb53e6f57ced37c557c971ca312235.png";